import React from 'react';

import {useHistory, useRouteMatch} from 'react-router-dom';

import {Button, Modal} from 'antd';
import type {ButtonProps} from 'antd/lib/button';
import {useFormikContext} from 'formik';

interface IProps extends ButtonProps {
  backPath?: string;
}

const {confirm} = Modal;

export const CancelButton: React.FC<IProps> = ({backPath, children = 'Cancel', ...props}) => {
  const match = useRouteMatch() as {url: string};
  const history = useHistory() as {push: (path: string) => void};
  const formik = useFormikContext();

  const goBack = () => {
    try {
      if (backPath) {
        history.push(backPath);
      } else {
        const path = match.url.split('/');
        path.pop();
        history.push(path.join('/'));
      }
    } catch (error) {
      console.error('Navigation error:', error);
    }
  };

  const onCancel = (dirty: boolean) => {
    if (!dirty) {
      goBack();
      return;
    }
    confirm({
      title: 'Discard changes?',
      content: 'Are you sure you want to discard your changes?',
      okText: 'Discard',
      okType: 'danger',
      onOk: goBack,
      onCancel() {}
    });
  };

  return (
    <Button
      onClick={() => {
        onCancel(formik.dirty);
      }}
      {...props}>
      {children}
    </Button>
  );
};
